// Pure scoring functions. No React, no DOM.

export function scoreFromData(d) {
  let s = 0;
  const ed = Math.abs(d.ema_diff_pct ?? 99);
  if (ed < 0.5 && d.trend_up) s += 30;
  else if (ed < 1.5 && d.trend_up) s += 18;
  else if (ed < 3.0) s += 7;

  const vr = d.vol_ratio ?? 0;
  if (vr > 1.5) s += 20;
  else if (vr > 1.2) s += 11;
  else if (vr > 1.0) s += 5;

  if (d.momentum_pct >= 6 && vr > 1.5) s += 25;
  else if (d.momentum_pct >= 4) s += 14;
  else if (d.momentum_pct >= 2) s += 6;

  if (d.rsi > 50 && d.rsi < 70 && d.trend_up) s += 15;
  else if (d.rsi > 45 && d.trend_up) s += 8;

  if (d.above_50d_ma) s += 10;
  return Math.min(s, 100);
}

export function toSignal(score) {
  if (score >= 72) return "STRONG";
  if (score >= 50) return "MODERATE";
  if (score >= 30) return "WATCH";
  return "NO_SIGNAL";
}

export const fmt = (n, d = 2) => Number(n || 0).toFixed(d);
export const fmtPct = (n) => (n >= 0 ? "+" : "") + Number(n || 0).toFixed(2) + "%";
export const fmtDol = (n) => "$" + Number(n || 0).toFixed(2);
export const fmtK = (n) => {
  if (n >= 1e12) return (n / 1e12).toFixed(1) + "T";
  if (n >= 1e9) return (n / 1e9).toFixed(1) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(0) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(0) + "K";
  return String(Math.round(n || 0));
};
